export const VARIANTS_NAMES = {
  DEFAULT: 'default',
  TESTS: 'tests',
  WORDPRESS: 'wordpress',
  SOSV: 'sosv',
  TEMPLATES: 'templates',
  LEADS: 'leads'
}
